import { createReducer } from '../lib/createReducer';

const initialState = {
  workflowLogExecutionContexts: {}
};

const MAX_WORKFLOW_LOG_EXECUTION_CONTEXTS = 5;

export default createReducer(initialState, {
  GET_WORKFLOW_LOG_EXECUTION_CONTEXT_SUCCESS: (state, payload) => {
    if (!payload?.meta?.workflowLogId) {
      return state;
    }

    const workflowLogExecutionContexts = {
      ...state.workflowLogExecutionContexts
    };

    delete workflowLogExecutionContexts[payload.meta.workflowLogId];
    workflowLogExecutionContexts[payload.meta.workflowLogId] = payload?.data;

    const workflowLogIds = Object.keys(workflowLogExecutionContexts);
    if (workflowLogIds.length > MAX_WORKFLOW_LOG_EXECUTION_CONTEXTS) {
      workflowLogIds.slice(0, workflowLogIds.length - MAX_WORKFLOW_LOG_EXECUTION_CONTEXTS).forEach((workflowLogId) => {
        delete workflowLogExecutionContexts[workflowLogId];
      });
    }

    return {
      ...state,
      workflowLogExecutionContexts
    };
  }
});
